import { Component, Inject } from '@angular/core';
import { CalibrationBalanceVariableConfig } from '../../../../model/calibrationBalance';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from '../../../../services/snackBar.service';
import { ArrayUtils } from '../../../../utils/arrayUtils';
import { v4 as uuid } from 'uuid';

export interface DialogDataCalibrationBalanceConfig {
  item: CalibrationBalanceVariableConfig;
}

@Component({
  selector: 'app-calibration-balance-edit-config-dialog-component',
  templateUrl: './calibration-balance-edit-config-dialog.component.html',
  styleUrl: './calibration-balance-edit-config-dialog.component.scss',
  standalone: false
})
export class CalibrationBalanceEditConfigDialogComponent {
   uniqueRange: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogDataCalibrationBalanceConfig,
    public dialogRef: MatDialogRef<CalibrationBalanceEditConfigDialogComponent>,
    private translate: TranslateService,
    public snackBarService: SnackBarService) { }

  ngOnInit(): void {
    if (ArrayUtils.isEmpty(this.data.item.points)) {
      this.data.item.points = [];
      let i = 1;
      while (i <= 5) {
          this.data.item.points.push(0);
          i++;
      }
    }

    if (!this.data.item.uuidConfig) {
      this.data.item.uuidConfig = uuid();
    }

    if (!this.data.item.points) {
      this.data.item.pointsLast = this.data.item.points;
    }
    this.uniqueRange = this.data.item.rangeInit != null && this.data.item.rangeEnd == null;
  }

  newValue(): void {
    this.data.item.points.push(0);
  }

  removeValue(index: number): void {
    this.data.item.points.splice(index, 1);
  }

  public setValue(index: number, value: number): void {
    this.data.item.points[index] = +value;
  }

  onOkClick(): void {

    const errs = [];

    if (this.data.item.rangeInit == null) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.calibrationData.range.init.error'));
    }

    if (!this.uniqueRange && this.data.item.rangeEnd == null) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.calibrationData.range.end.error'));
    }

    if (this.data.item.resolution == null) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.calibrationData.resolution.error'));
    }

    if (this.data.item.uncertaintyResolution == null) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.calibrationData.resolutionU.error'));
    }

    if (ArrayUtils.isEmpty(this.data.item.points)) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.asLeft.dialog.values.error'));
    } else {
      if (this.data.item.points.filter(v => v === null).length !== 0) {
        errs.push(this.translate.instant('calibrateEquipmentEdit.calibrationData.point.error'));
      }
    }

    if (errs.length === 0) {
      if (this.uniqueRange) {
        this.data.item.rangeEnd = null;
      }

      if (!this.data.item.pointsLast) {
        this.data.item.pointsLast = this.data.item.points;
      }

      this.dialogRef.close(this.data.item);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
